/** Deliberately permissive — the server is the authority on deliverability. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const MIN_PASSWORD_LENGTH = 8;
export const MIN_USERNAME_LENGTH = 3;

export function isEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function requiredText(value: string, label: string): string | undefined {
  return value.trim() ? undefined : `${label} is required.`;
}

export function emailError(value: string, label = 'Email'): string | undefined {
  if (!value.trim()) return `${label} is required.`;
  return isEmail(value) ? undefined : 'Enter a valid email address.';
}

export function passwordError(value: string, label = 'Password'): string | undefined {
  if (!value) return `${label} is required.`;
  return value.length >= MIN_PASSWORD_LENGTH
    ? undefined
    : `${label} must be at least ${MIN_PASSWORD_LENGTH} characters.`;
}

export function usernameError(value: string, label = 'Username'): string | undefined {
  if (!value.trim()) return `${label} is required.`;
  return value.trim().length >= MIN_USERNAME_LENGTH
    ? undefined
    : `${label} must be at least ${MIN_USERNAME_LENGTH} characters.`;
}

/** Strips keys whose value is undefined, so `Object.keys(...)` counts real errors. */
export function compactErrors<T extends string>(
  errors: Partial<Record<T, string | undefined>>,
): Partial<Record<T, string>> {
  const result: Partial<Record<T, string>> = {};
  for (const [key, value] of Object.entries(errors) as Array<[T, string | undefined]>) {
    if (value) result[key] = value;
  }
  return result;
}
